import React from 'react';

const ConfirmModal = ({ title, totalRecords, onConfirm, onCancel }) => {

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm();
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        {title === 'Edit Users' ? (
          <> 
          <h2 className="font-semibold">Update Edited User{totalRecords > 1 ? 's' : ''}</h2>
          <p className="mb-8">Are you sure you want to update these {totalRecords.toLocaleString('en-US')} user{totalRecords > 1 ? 's' : ''}?</p>
          </>
        ) : (
          <>
          <h2 className="font-semibold">Invite Email{totalRecords > 1 ? 's' : ''}</h2>
          <p className="mb-8">Are you sure you want to invite these {totalRecords.toLocaleString('en-US')} email{totalRecords > 1 ? 's' : ''}?</p>
          </>
        )}

        <div className="flex gap-4">
          <button
            type="submit"
            className="p-4 font-semibold rounded-lg bg-purple text-white hover:bg-purple-700"
          >
            {title === 'Edit Users' ? (
              <> 
              Confirm User Updates
            </>
            ) : (
              <>
              Confirm
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="font-semibold p-4 rounded-lg bg-gray-300 text-gray-700"
          >
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};

export default ConfirmModal;
